/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	'./livewidget/LiveWidget',
	'./livewidget/LiveWidgetUIHelper',
	'./livewidget/models/LiveWidgetModel',
	'./livewidget/features/SampleFeature',

	'../dataSources/models/DataSourcesModel',
	'../dataSources/models/sources/SourcesCollection',
	'../dataSources/modelapis/SourceModelAPI',
	'../dataSources/modelapis/ModuleAPI',
	'../dataSources/modelapis/modelmanagers/SourceModelManager',

	'../visualizations/vipr/extendedVis/SchematicEditorUI'
], function() {
	'use strict';
});
